<template>
  <div class="main">
    <div class="text">
      <div class="line"></div>
      <span class="desc">最近看过的H5案例</span>
    </div>
    <div class="container">
      <my-card v-for="item in items" :key="item.id" :item="item" :wxurl="getWeb(item.h5url)" :img="getImg(item.img)" :name="item.name" :time="getTime(item.time)" />
    </div>
    <span v-on:click="go">
      <img src="../assets/page04_btn.png" alt="button" class="btn-img">
    </span>
    <rotate-it />
  </div>
</template>

<script>
import { getData } from '../utils/mock.js'
import { trans } from '../utils/timeTrans.js'
import Card from './Card'
import Rotate from './Rotate'
export default {
  name: 'Pg4',
  components: {
    'my-card': Card,
    'rotate-it': Rotate
  },
  data () {
    return { items: getData() }
  },
  methods: {
    go () {
      this.$router.push('/')
    },
    getImg (url) {
      return `https://niu.h5anli.com/${url}`
    },
    getWeb (url) {
      return `https://www.h5anli.com/${url}`
    },
    getTime (t) {
      const now = new Date().getTime()
      const timeDiff = trans(now, t)
      return timeDiff
    }
  },
  mounted:function(){
    window.ondevicemotion = null
  }
}
</script>

<style type="text/css" scoped>
  .main {
    background-color: #f8f8f8;
    width: 100vw;
    min-height: 100vh;
    position: relative;
  }

  .text {
    position: relative;
    color: #949494;
    padding-top: 5.13vw;
    padding-bottom: 7.2vw;
    text-align: center;
    font-size: .6rem;
    z-index: 1;
  }

  .container {
    width: 100vw;
    padding-bottom: 5rem;
  }

  .btn-img {
    position: absolute;
    bottom: 6.667vw;
    /* display: block; */
    left: 20vw;
    width: 60.4vw;
  }

  .line {
    position: relative;
    border: none;
  }

  .line::before {
    content: '';
    position: absolute;
    z-index: -1;
    pointer-events: none;
    background-color: #ddd;
    height: 1px;
    left: 0;
    right: 0;
    bottom: -8px;
  }

  .desc {
    background-color: #f8f8f8;
  }

  @media only screen and (-webkit-min-device-pixel-ratio: 2) {
    .line::before {
      content: '';
      position: absolute;
      z-index: -1;
      pointer-events: none;
      background-color: #ddd;
      height: 1px;
      left: 0;
      right: 0;
      bottom: -8px;
    }
    -webkit-transform: scaleY(0.5);
    -webkit-transform-origin: 50% 0%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pg4.vue